import { useEffect } from 'react';
import { pushBackLayer } from './backStack.ts';

/**
 * Let the device Back gesture close this thing, rather than the app.
 *
 * The layering lives in `backStack.ts`; this is only the React binding. Every
 * dismissible surface should use it, and the one on top wins — a photo opened
 * inside a conversation takes the first Back, the conversation takes the next.
 */
export function useBackButton(isOpen: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!isOpen) return;
    return pushBackLayer(onClose);
  }, [isOpen, onClose]);
}
